import withSubcomponents from "../../lib/withSubcomponents";
import HorizontalSwipeable from "../HorizontalSwipeable";
import Item from "./components/Item";
/**
 * Shows a horizontal navigation with plain text navigation items
 *
 * Use the `InlineNavigation` as a container for `InlineNavigationItems`
 */
const Component = HorizontalSwipeable;
export const InlineNavigation = withSubcomponents(Component, {
    Item,
});
export default InlineNavigation;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiSW5saW5lTmF2aWdhdGlvbi5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb21wb25lbnRzL0lubGluZU5hdmlnYXRpb24vSW5saW5lTmF2aWdhdGlvbi50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsT0FBTyxpQkFBaUIsTUFBTSw2QkFBNkIsQ0FBQztBQUM1RCxPQUFPLG1CQUFtQixNQUFNLHdCQUF3QixDQUFDO0FBQ3pELE9BQU8sSUFBSSxNQUFNLG1CQUFtQixDQUFDO0FBRXJDOzs7O0dBSUc7QUFDSCxNQUFNLFNBQVMsR0FBRyxtQkFBbUIsQ0FBQztBQUV0QyxNQUFNLENBQUMsTUFBTSxnQkFBZ0IsR0FBRyxpQkFBaUIsQ0FBQyxTQUFTLEVBQUU7SUFDM0QsSUFBSTtDQUNMLENBQUMsQ0FBQztBQUVILGVBQWUsZ0JBQWdCLENBQUMifQ==